import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {BranchModel} from "../../../branches/models/branch.model";
import {TaskPurposeType} from "../../types/task-purpose.type";

const TASK_PURPOSE_VALUES: string[] = _.values(TaskPurposeType);

export class bringozTimelineLogsTableRowCtrl implements IController {
  log: any;

  private templateData: any;

  constructor(private $translate, private $filter, private $branches) {
  }

  $onInit() {
    this._setTranslatedTemplateData();
  }

  $onChanges(changes) {
    if (changes.log) {
      this._setTranslatedTemplateData();
    }
  }

  private _translateSubject(subject: any): string {
    if (!_.isString(subject) || _.isEmpty(subject)) {
      return subject;
    }
    const purposeKey = _.find(
      TASK_PURPOSE_VALUES,
      (key) => _.toLower(key) === _.toLower(subject)
    );
    if (purposeKey) {
      return this.$translate.instant('TASK_PURPOSE.' + purposeKey);
    }
    return this.$translate.instant(subject);
  }

  private _setTranslatedTemplateData() {
    this.templateData = _.map(this.log.templateData, (event) => {

      const eventCopy = angular.copy(event);

      _.forOwn(event, (value, key) => {
        eventCopy[key] = key === 'subject'
          ? this._translateSubject(value)
          : this.$translate.instant(value);
      })

      if (!eventCopy.oldValue) {
        eventCopy.oldValue = this.$translate.instant('None');
      }
      if (!eventCopy.newValue) {
        eventCopy.newValue = this.$translate.instant('None');
      }

      if (
        eventCopy.fieldName === 'notBefore' || eventCopy.fieldName === 'notAfter' ||
        eventCopy.fieldName === 'startTime' || eventCopy.fieldName === 'endTime' ||
        eventCopy.fieldName === 'startRecurring' || eventCopy.fieldName === 'endRecurring' ||
        eventCopy.fieldName === 'pickupTask_notBefore' || eventCopy.fieldName === 'pickupTask_notAfter' ||
        eventCopy.fieldName === 'destinationTask_notBefore' || eventCopy.fieldName === 'destinationTask_notAfter'
      ) {
        eventCopy.oldValue = this.$filter('bringozDate')({oldValue: parseInt(eventCopy.oldValue)}, 'oldValue', true);
        eventCopy.newValue = this.$filter('bringozDate')({newValue: parseInt(eventCopy.newValue)}, 'newValue', true);
      }


      if (eventCopy.fieldName === 'serviceIds') {

        const oldServiceIdsToArr = _.split(eventCopy.oldValue.replace(/[\[\]]/g, ''), ', ');
        const newServiceIdsToArr = _.split(eventCopy.newValue.replace(/[\[\]]/g, ''), ', ');
        const serviceIdsToAdd = _.difference(newServiceIdsToArr, oldServiceIdsToArr);
        const serviceIdsToRemove = _.difference(oldServiceIdsToArr, newServiceIdsToArr);

        if (serviceIdsToAdd.length) {
          eventCopy.newValue = _.join(serviceIdsToAdd, ', ');
          if (serviceIdsToAdd.length > 1) {
            eventCopy.subject = this.$translate.instant('Services');
          } else {
            eventCopy.subject = this.$translate.instant('Service');
          }
        }

        if (serviceIdsToRemove.length) {
          eventCopy.newValue = _.join(serviceIdsToRemove, ', ');
          if (serviceIdsToRemove.length > 1) {
            eventCopy.subject = this.$translate.instant('Services');
          } else {
            eventCopy.subject = this.$translate.instant('Service');
          }
        }

      }
      eventCopy.fieldName = this.$translate.instant('TIMELINE_LOG_FIELD_NAME.' + event.fieldName);
      return eventCopy;
    });


    function IsJsonString(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    }
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozTimelineLogsTableRow', {
    bindings: {
      log: '<'
    },
    template: require('./bringoz-timeline-logs-table-row.html').default,
    controller: bringozTimelineLogsTableRowCtrl
  });
